//Paquetes NPM de GYF. 
import { LogHelper } from 'com-gyf-webcore-loghelper';
import { Engine1Proxy, RestApiProxy, RabbitListener, SagasProxy, ConciergeProxy } from 'com-gyf-webcore-servicehub';
import Helper from '../../../Common/Helpers/GlobalHelper';


//Seteo de apiUrl
RestApiProxy.SetApiUrl();


let _dispatch;


//ACTION TYPES
export const GET_SCREEN_DATA_AVISO_VIAJE = 'GET_SCREEN_DATA_AVISO_VIAJE';
export const MODAL_VIAJES = 'MODAL_VIAJES';
export const EDITAR_VIAJE = 'EDITAR_VIAJE';
export const CHECK_VIAJES = 'CHECK_VIAJES';
export const SELECCIONAR_FECHA = 'SELECCIONAR_FECHA';
export const SELECCIONAR_DESTINO = 'SELECCIONAR_DESTINO';
export const SELECCION_DESTINOS_ORIGINAL = 'SELECCION_DESTINOS_ORIGINAL';



export function getDataInicial(clienteId){

    return (dispatch,getState)=>{
        _dispatch = dispatch;
        let state = getState();
        let tarjetas = JSON.parse(JSON.stringify(state.tarjetas));
        let paramDom = {"CLIENTE_ID": clienteId};
    
        Engine1Proxy.AddDataSourcesRequests(paramDom, 'GET_DATA_INICIAL_EDICION_AVISO_VIAJE', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true);
        Engine1Proxy.AddDataSourcesRequests(paramDom, 'GET_DATOS_AVISO_VIAJE_PantallaPrincipal', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true);
        Engine1Proxy.AddDataSourcesRequests(paramDom, 'GET_DATOS_AVISO_VIAJE_IntegrantesCuenta', 'Get', 'Tarjetas', 'CONSULTASOCIOS', null, 'User', true);
    
        Engine1Proxy.Execute((data)=>_getDataInicialCallback(data,tarjetas), null, null, "CONSULTASOCIOS");
    }
}

function _getDataInicialCallback(data,tarjetas){
    let avisosViajePrincipalRaw = JSON.parse(data.GET_DATOS_AVISO_VIAJE_PantallaPrincipal).Recordset1.Rows;
    let integrantesAvisosViajeRaw = JSON.parse(data.GET_DATOS_AVISO_VIAJE_PantallaPrincipal).Recordset0.Rows;
    let paises = JSON.parse(data.GET_DATA_INICIAL_EDICION_AVISO_VIAJE).Recordset0.Rows;
    let cuentas = JSON.parse(data.GET_DATA_INICIAL_EDICION_AVISO_VIAJE).Recordset1.Rows;
    let tarjetasAux = JSON.parse(data.GET_DATA_INICIAL_EDICION_AVISO_VIAJE).Recordset2.Rows;

    let arregloCuentas = [];
    let arregloViajesFinal = [];
    
    String.prototype.capitalize = function() {
        let lowerText= this.toLowerCase();
        let separated = lowerText.split(" ");
        let sepAux = [];

        separated.map(s=>{
           sepAux.push( s= s.charAt(0).toUpperCase() + s.slice(1));
        });

        return sepAux.join(" ");
    }

    cuentas.map(c=>{
        let Cuenta = {
            Numero: c.Numero,
            Descripcion: c.Marca + "-"+ c.DescripcionCuenta.replace("TARJETA",""),
            Id: c.CuentaTarjetaId,
            Tarjetas:[]
        }
        arregloCuentas.push(Cuenta);
    });

    tarjetasAux.map(t=>{
        let Tarjeta = {
            Nombre: t.TitularNombreCliente ? t.TitularNombreCliente.capitalize() : "",
            Numero:t.Numero,
            Id: t.Id
        }
        arregloCuentas.map(c=>{
            if(c.Id == t.CuentaTarjetaId) c.Tarjetas.push(Tarjeta);
        })
    })
    
    
    //SI NO EXISTE EL VIAJE EN EL ARREGLO FINAL SE AGREGA UN NUEVO OBJETO CON LA ESTRUCTURA CORRESPONDIENTE
    avisosViajePrincipalRaw.map(aviso=>{
        if(!arregloViajesFinal.some(v=>v.Id==aviso.AvisoViajeCabeceraId)){
            let nuevoViaje = {
                Id: aviso.AvisoViajeCabeceraId,
                Partida: aviso.FechaInicio,
                Regreso: aviso.FechaFin,
                FechaAlta:aviso.FechaAlta,
                Destinos:[],
                Cuentas:[]
            }
            arregloViajesFinal.push(nuevoViaje);
        }
    });

    avisosViajePrincipalRaw.map(aviso=>{
        arregloViajesFinal.map(vf=>{
            if(vf.Id == aviso.AvisoViajeCabeceraId){
                //SI ENTRE LAS CUENTAS DEL VIAJE CORRESPONDIENTE YA ESTÁ AGREGADA LA DEL REGISTRO EN CUESTIÓN SE LE AGREGAN LAS TARJETAS
                if(vf.Cuentas.some(c=>c.Numero == aviso.NroCuenta)){
                    vf.Cuentas.map(c=>{
                        if(c.Numero == aviso.NroCuenta){
                            if(!c.Tarjetas.some(t=>t.Numero == aviso.NroTarjeta)){
                                let nuevaTarjeta = {
                                    Nombre: aviso.NombreIntegrante ? aviso.NombreIntegrante.capitalize() : "",
                                    Numero:aviso.NroTarjeta
                                }
                                c.Tarjetas.push(nuevaTarjeta);
                            }
                        }
                    })
                }else{
                    //SI NO EXISTÍA LA CUENTA PARA ESE VIAJE, SE AGREGA EL OBJETO CUENTA CON LA PRIMER TARJETA ASOCIADA
                    let nuevaCuenta = {
                        Numero: aviso.NroCuenta,
                        Descripcion: aviso.Marca + " - "+ aviso.TipoCuenta.replace("TARJETA",""),
                        Tarjetas:[{
                            Nombre: aviso.NombreIntegrante ? aviso.NombreIntegrante.capitalize() : "" ,
                            Numero:aviso.NroTarjeta
                        }]
                    }
                    vf.Cuentas.push(nuevaCuenta)
                }
            }
            //SE AGREGAN LOS DESTINOS AL VIAJE
            if(!vf.Destinos.some(d=>aviso.Destino.toLowerCase() == d.Descripcion.toLowerCase())){
                vf.Destinos.push({Descripcion: aviso.Destino ? aviso.Destino.capitalize() : "" , Id: aviso.PaisId});
            }
        })
    })

    _dispatch({type: GET_SCREEN_DATA_AVISO_VIAJE, viajes:arregloViajesFinal.reverse(),paises,arregloCuentas})
}



export function modalViajes(modal,abrir){
    return (dispatch, getState)=>{
        let state = JSON.parse(JSON.stringify(getState()));

        switch(modal){
            case "SELECCIONAR_DESTINOS":{
                let seleccion = [];

                state.avisoViaje.paisesEdicion.map(p=>{if(p.Checked) seleccion.push(p.Id)})

                dispatch({type:SELECCION_DESTINOS_ORIGINAL, seleccion})

                break;
            }
        }

        dispatch({type:MODAL_VIAJES, modal, abrir})
    }
}


export function editarViaje(viaje, accion){
    
    return (dispatch, getState)=>{
        let state = getState();
        state = JSON.parse(JSON.stringify(state.avisoViaje));
        let cuentasEdicion = state.Cuentas;
        let paisesEdicion = state.paises;
        let fechaPartida = accion && viaje.Partida;
        let fechaRegreso = accion && viaje.Regreso;

        //SI ACCION ES TRUE SE PASA TODA LA DATA PARA LA MODIFICACIÓN, CASO CONTRARIO, SE LIMPIAN LAS PROPIEDADES
        if(accion){
            viaje.Cuentas.map(c=>{
               cuentasEdicion.map(c2=>{
                   if(c2.Numero == c.Numero){
                       c2.Tarjetas.map(t=>{
                           if(c.Tarjetas.some(t2=>t2.Numero == t.Numero)) t.Checked = true;
                       })
                   }
               })
            })
    
            viaje.Destinos.map(d=>{
                paisesEdicion.map(p=>{
                    if(p.Id == d.Id) p.Checked = true;
                })
            })
            
            cuentasEdicion.map(cuenta=>{
                cuenta.Checked = !cuenta.Tarjetas.some(t=>!t.Checked);
            })
                
            dispatch({type:EDITAR_VIAJE, cuentasEdicion, paisesEdicion,fechaPartida, fechaRegreso, accion, viajeEdicion: viaje, esModificacion:true})
        }else{
            dispatch({type:EDITAR_VIAJE, accion})
        }
    }
}

export function checkViaje(tarjetaId, cuentaId, checkCuenta){
    return (dispatch,getState)=>{
        let state = getState();
        state = JSON.parse(JSON.stringify(state.avisoViaje));
        let cuentasEdicion = state.cuentasEdicion;

        if(checkCuenta){
            cuentasEdicion.map(c=>{
                if(c.Id == cuentaId){
                    c.Checked = !c.Checked;
                    c.Tarjetas.map(t=>t.Checked = c.Checked);
                }
            })
        }else{
            cuentasEdicion.map(c=>{
                if(c.Id == cuentaId){
                    c.Tarjetas.map(t=>{
                        if(t.Id == tarjetaId) t.Checked = !t.Checked;
                    });
                    c.Checked = !c.Tarjetas.some(t=>!t.Checked);
                }
            })
        }

        dispatch({type: CHECK_VIAJES, cuentasEdicion})
    }
}

export function seleccionarFecha(campo, fecha){
    return (dispatch,getState)=>{
        dispatch({type:SELECCIONAR_FECHA, campo, fecha})
    }
}

export function seleccionarDestino(destinoId){
    return (dispatch,getState)=>{
        let state = getState();
        let destinos = JSON.parse(JSON.stringify(state.avisoViaje.paisesEdicion));

        destinos.map(d=>{
            if(d.Id == destinoId) d.Checked = !d.Checked;
        });

        dispatch({type:SELECCIONAR_DESTINO, destinos})
    }
}

export function cancelarSeleccionDestinos(){
    //función que se llama al cerrar el modal de selección de destinos (sin confirmar) para que las selecciones de destinos vuelvan a lo que había antes de abrir el modal
    return (dispatch,getState)=>{
        let state = getState();
        state = JSON.parse(JSON.stringify(state.avisoViaje));
        let paisesEdicion = state.paises;

        state.paisesSeleccionActual.map(p=>{
            paisesEdicion.map(p2=>{
                if(p2.Id == p) p2.Checked = true;
            })
        })
        
        dispatch({type:SELECCIONAR_DESTINO, destinos: paisesEdicion})
        dispatch({type:SELECCION_DESTINOS_ORIGINAL, destinos: []})
    }
}

export function nuevoViaje(){
    return (dispatch, getState)=>{
        let state = getState();
        state = JSON.parse(JSON.stringify(state.avisoViaje));
        let cuentasEdicion = state.Cuentas;
        let paisesEdicion = state.paises;
        let fechaPartida = Helper.ConvertirFecha(new Date().toLocaleDateString(),true,true);
        let fechaRegreso = Helper.ConvertirFecha(new Date().toLocaleDateString(),true,true);

        dispatch({type:EDITAR_VIAJE, cuentasEdicion, paisesEdicion,fechaPartida, fechaRegreso, accion: true, viajeEdicion: null})
    }
}